import { Component, input } from '@angular/core';

@Component({
    selector: 'app-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.css'],
    host: {
        '[class.hidden]': "animationState() === 'hidden'",
    },
})
export class OverlayComponent {
    readonly animationState = input<'visible' | 'hidden'>('visible');
}
